import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import Banner from '~/components/Banner';
import SignUpBtn from '~/components/auth/SignUpBtn';
import authStore from '~/stores/authStore';
import HowItWorks from './HowItWorks';
import SpeechFeatures from './SpeechFeatures';
import SpeechParallax from './SpeechParallax';
import SpeechCodeExample from './SpeechCodeExample';

const useStyles = makeStyles(({ palette }) =>
    createStyles({
        text: {
            color: palette.background.paper,
            textShadow: `1px 1px 1px ${palette.primary.dark}`
        }
    })
);

const langLib = {
    en: {
        title: 'Call Transcription API',
        subtitle: 'Turn audio recordings into accurate text.',
        billing: 'Russian & English · Speaker detection · Pay per minute, no subscriptions.',
        getStarted: 'Get started'
    },
    ru: {
        title: 'API расшифровки звонков',
        subtitle: 'Превращаем голосовые записи в точный текст.',
        billing: 'Русский и английский · Определение спикеров · Поминутная оплата без подписки.',
        getStarted: 'Начать использовать'
    }
} as const;

const Speech = () => {
    const classes = useStyles();
    const { lang } = authStore;
    const lib = langLib[lang];

    return (
        <>
            <Banner style={{ height: '400px' }}>
                <Typography variant="h2" component="h1" className={classes.text} align="center">
                    {lib['title']}
                </Typography>
                <Typography className={classes.text} align="center">
                    {lib['subtitle']}
                    <br />
                    {lib['billing']}
                </Typography>
                <SignUpBtn>
                    <Button color="primary" variant="contained" size="large">
                        {lib['getStarted']}
                    </Button>
                </SignUpBtn>
            </Banner>
            <HowItWorks />
            <SpeechFeatures />
            <SpeechParallax />
            <SpeechCodeExample />
        </>
    );
};

export default observer(Speech);
